import { Inventory, Status } from '@/hooks/useInventory';

export const getInventoryQuantity = ({
  useInventoryData,
  defaultQuantity,
}: {
  useInventoryData: {
    status: Status;
    error: null | unknown;
    data?: Inventory;
  };
  defaultQuantity: number;
}) => {
  if (useInventoryData.status !== 'success') {
    return defaultQuantity;
  }

  return useInventoryData.data.reduce((acc, curr) => acc + curr.quantity, 0);
};
